/**
 *
 * Organizations/Sequences/Form
 *
 */

import React from 'react'

// NPM Libraries

// GraphQL
import { gql, useMutation } from '@apollo/client'

// Components
import FloatingLabel from '@joeyparis/react-floating-label-input'
import { useHandleInputChange } from 'hooks'
import { ready_made_topics } from '..'

const CREATE_SEQUENCE = gql`
	mutation createSequence($organization_id: ID, $name: String, $topic_value: String) {
		createSequence(input: { organization_id: $organization_id, name: $name, topic_value: $topic_value }) {
			sequence {
				id
			}
		}
	}
`

function SequenceForm({ sequence: { name, topic_value, is_copy }, organization_id, handleClose }) {
	const [state, handleInputChange] = useHandleInputChange({ name, topic_value })

	const [createSequence, { loading: creating }] = useMutation(CREATE_SEQUENCE, { onCompleted: handleClose })

	const handleSubmit = (e, mutate) => {
		e.preventDefault()

		mutate({
			variables: {
				organization_id,
				name: state.name,
				topic_value: state.topic_value,
			},
		})

		return false
	}

	return (
		<form onSubmit={(e) => handleSubmit(e, createSequence)}>
			<h2>{is_copy ? 'Copy' : 'Create'} Sequence</h2>

			<FloatingLabel
				type="text"
				name="name"
				label="Name"
				value={state.name}
				onChange={handleInputChange}
				autoFocus
			/>

			{!is_copy && (
				<FloatingLabel
					type="select"
					name="topic_value"
					label="Sequence Topic Type"
					value={state.topic_value}
					onChange={handleInputChange}
					options={Object.keys(ready_made_topics).map((topic_key) => ({
						text: ready_made_topics[topic_key],
						value: topic_key,
					}))}
				/>
			)}

			<div className="d-flex justify-content-end mt-3">
				<button className="btn btn-danger mr-2" onClick={handleClose} disabled={creating}>
					Cancel
				</button>

				<button type="submit" className="btn btn-primary" disabled={creating}>
					{is_copy ? 'Copy' : 'Create'} Sequence
				</button>
			</div>
		</form>
	)
}

SequenceForm.propTypes = {}

export default SequenceForm
